var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoffeePot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M431.5 177.625L480 32H88C39.375 32 0 71.375 0 120V208C0 216.875 7.125 224 16 224H48C56.875 224 64 216.875 64 208V136C64 113.875 81.875 96 104 96H117.375L144.75 178.125C95.375 217.875 64 277.75 64 344.625C64 396.125 82.625 429.375 113.625 462.375C124.5 473.625 139.5 480 155.125 480H420.875C436.5 480 451.5 473.75 462.25 462.375C493.25 429.5 512 396.125 512 344.625C512 278.375 481.375 217.875 431.5 177.625ZM445.875 320H130.625C137.375 281 159.5 247.125 191.125 224H386.875C417.875 247.25 439.5 281.25 445.875 320Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeePot);
export default __webpack_public_path__ + "static/media/coffee-pot.146b279a6bcf29f12adf78372e112c39.svg";
export { ForwardRef as ReactComponent };